// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".splash___main___1-B48 {\n    font-size: 14px;\n    min-height: 100vh;\n    background: #0c161c;\n}\n", ""]);
// Exports
exports.locals = {
	"main": "splash___main___1-B48"
};
module.exports = exports;
